import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { Typography } from '~/components/elements/Typography'
import { useFormField } from '~/hooks/useFormField'

import { renderSelectorContext } from '../../contexts'
import { type InputValues } from '../../utils'

export type DiffItemSelectorsProps = {
  index: number
  onDelete: (index: number) => void
}

export const DiffItemSelectors = ({
  index,
  onDelete,
}: DiffItemSelectorsProps) => {
  const { t } = useTranslation()
  const renderSelector = React.useContext(renderSelectorContext)
  const { control } = useFormContext<InputValues>()
  const leftField = useFormField(control, `diffs.${index}.0`)
  const rightField = useFormField(control, `diffs.${index}.1`)

  const handleDeleteButtonClick = React.useCallback<
    EH<IconButtonProps, 'onClick'>
  >(() => {
    onDelete(index)
  }, [index, onDelete])

  return (
    <HStack align="center" spacing={2}>
      {renderSelector(leftField, rightField.value)}

      <Typography variant="normal">{t('vs')}</Typography>

      {renderSelector(rightField, leftField.value)}

      <IconButton
        buttonStyle="light"
        fillMode="flat"
        icon="delete"
        onClick={handleDeleteButtonClick}
      />
    </HStack>
  )
}
